import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import RootLayout from '@/layouts/RootLayout';

/**
 * 优了个优
 */
var miniGame = {
  path: '/miniGame',
  component: RootLayout,
  redirect: '/miniGame/ulu',
  children: [{
    path: '/miniGame/ulu',
    name: 'MiniGame',
    component: function component() {
      return import('@/views/miniGame/Index');
    },
    meta: {
      title: '优了个优'
    }
  }, {
    path: '/miniGame/cards',
    name: 'GameCards',
    component: function component() {
      return import('@/views/miniGame/Cards');
    },
    meta: {
      title: '技能卡'
    }
  }, {
    path: 'woodenFish',
    name: 'WoodenFish',
    component: function component() {
      return import('@/views/miniGame/woodenFish/index.vue');
    },
    meta: {
      title: '敲敲木鱼'
      // normal: true // 普通页面，不需要登陆查询信息接口
    }
  }]
};
export default miniGame;